import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Header.css";
import logoEleven from "../assets/images/only-elven.png";
import logoFull from "../assets/images/logo.png.png";
import { trackNavigation } from "../utils/mixpanel";

function Header({ showFullLogo }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [logoVisible, setLogoVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (showFullLogo) {
      setLogoVisible(true);
    } else {
      setLogoVisible(false);
    }
  }, [showFullLogo]);

  // Handle hash scrolling after navigation
  useEffect(() => {
    if (location.hash === "#about") {
      const el = document.getElementById("about");
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
      }
    }
  }, [location]);

  const handleAboutClick = (e) => {
    e.preventDefault();
    trackNavigation(location.pathname, "About");
    if (location.pathname === "/") {
      const el = document.getElementById("about");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#about");
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/">
            {showFullLogo ? (
              <img
                src={logoFull}
                alt="Eleven Power"
                className={`logo-full ${logoVisible ? "logo-visible" : "logo-hidden"}`}
              />
            ) : (
              <img src={logoEleven} alt="Eleven" className="logo-eleven" />
            )}
          </Link>
        </div>
        <nav className="header-nav">
          <Link to="/#about" className="nav-link" onClick={handleAboutClick}>
            About
          </Link>
          <span className="nav-dot">•</span>
          <Link to="/careers" className="nav-link" onClick={() => trackNavigation(location.pathname, "Careers")}>
            Careers
          </Link>
          <span className="nav-dot">•</span>
          <Link to="/register" className="nav-link" onClick={() => trackNavigation(location.pathname, "Register")}>
            Register
          </Link>
        </nav>
        {/* <Link to="#footer" className="header-cta">
          Contact us <span>+</span>
        </Link> */}
        <button
          className="header-hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          ☰
        </button>
      </div>

      {menuOpen && (
        <div className="mobile-menu">
          <a
            href="#about"
            className="mobile-menu-link"
            onClick={(e) => { handleAboutClick(e); setMenuOpen(false); }}
          >
            About
          </a>
          <Link
            to="/careers"
            className="mobile-menu-link"
            onClick={() => setMenuOpen(false)}
          >
            Careers
          </Link>
          <Link
            to="/register"
            className="mobile-menu-link"
            onClick={() => setMenuOpen(false)}
          >
            Register
          </Link>
          {/* <a
            href="#footer"
            className="mobile-menu-link"
            onClick={() => setMenuOpen(false)}
          >
            Contact us
          </a> */}
        </div>
      )}
    </header>
  );
}

export default Header;
